module.exports = __webpack_public_path__ + "img/main_technic_6.9d81d3ac.jpg";